import React, {useEffect} from "react";
import Styles from './styles.module.scss'

import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";

import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import CabinetHello from "../../components/_UI/cabinetHello";
import CabinetMainBalance from "../../components/cabinet/cabinetMainBalance";
import CabinetMainCapsule from "../../components/cabinet/cabinetMainCapsule";
import CabinetMainReferral from "../../components/cabinet/cabinetMainReferral";
import CabinetMainArks from "../../components/cabinet/cabinetMainArks";
import CabinetMainNotifications from "../../components/cabinet/cabinetMainNotifications";
import CabinetMainTopUpModal from "../../components/cabinet/cabinetMainTopUpModal";
import CabinetMainWithdrawModal from "../../components/cabinet/cabinetMainWithdrawModal";

import {getDashboard} from "../../store/cabinet/action";

const CabinetPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const authStatus = useSelector(store => store.main.authorizationStatus);

    useEffect(()=>{
        if (!authStatus){
            navigate('/sign-in');
        }
    },[authStatus, navigate])

    useEffect(()=>{
        if (authStatus){
            dispatch(getDashboard());
        }
    },[authStatus, dispatch])

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Кабинет')}/>
            <div className={`${Styles.posWrap}`}>
                <div className={`${Styles.colCenter}`}>
                    <div className={`${Styles.helloWrap} ${Styles.cabinetPC}`}>
                        <CabinetHello
                            title={t('Добро пожаловать в Time Capsule!')}
                            description={t('Будущее начинается с того, что ты оставишь после себя.')}
                        />
                    </div>
                </div>
                <div className={`${Styles.colLeft}`}>
                    <CabinetMainBalance/>
                    <CabinetMainCapsule/>
                    <CabinetMainReferral/>
                </div>
                <div className={`${Styles.colRight}`}>
                    <CabinetMainArks/>
                    <CabinetMainNotifications/>
                </div>
            </div>

            <CabinetMainTopUpModal/>
            <CabinetMainWithdrawModal/>
        </section>
    );
};

export default CabinetPage;
